import { render, staticRenderFns } from "./BusinessAdvantages.vue?vue&type=template&id=67ba517e&scoped=true"
import script from "./BusinessAdvantages.vue?vue&type=script&lang=js"
export * from "./BusinessAdvantages.vue?vue&type=script&lang=js"
import style0 from "./BusinessAdvantages.vue?vue&type=style&index=0&id=67ba517e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba517e",
  null
  
)

export default component.exports